<section class="deployment-page">

  <nav class="program-tabs" role="tablist" aria-label="Program deployment sub pages">
    <button type="button" class="program-tab" [class.active]="activeProgramPage === 'summary'"
      (click)="selectProgramPage('summary')" role="tab" [attr.aria-selected]="activeProgramPage === 'summary'">
      Deployment Summary
    </button>
    <button type="button" class="program-tab" [class.active]="activeProgramPage === 'connectivity'"
      (click)="selectProgramPage('connectivity')" role="tab" [attr.aria-selected]="activeProgramPage === 'connectivity'">
      Connectivity
    </button>
    <button *ngIf="showRestrictedTabs" type="button" class="program-tab" [class.active]="activeProgramPage === 'dataHealth'"
      (click)="selectProgramPage('dataHealth')" role="tab" [attr.aria-selected]="activeProgramPage === 'dataHealth'">
      Data Health
    </button>
    <button *ngIf="showRestrictedTabs" type="button" class="program-tab" [class.active]="activeProgramPage === 'namcShopDetail'"
      (click)="selectProgramPage('namcShopDetail')" role="tab" [attr.aria-selected]="activeProgramPage === 'namcShopDetail'">
      NAMC-Shop
    </button>
  </nav>

  <div *ngIf="activeProgramPage === 'summary'" role="tabpanel" class="program-tab-content">
    <app-deployment-summary></app-deployment-summary>
  </div>

  <div *ngIf="activeProgramPage === 'connectivity'" role="tabpanel" class="program-tab-content">
    <app-deployment-connectivity></app-deployment-connectivity>
  </div>

  <div *ngIf="showRestrictedTabs && activeProgramPage === 'dataHealth'" role="tabpanel" class="program-tab-content">
    <app-deployment-data-health></app-deployment-data-health>
  </div>

  <div *ngIf="showRestrictedTabs && activeProgramPage === 'namcShopDetail'" role="tabpanel" class="program-tab-content">
    <app-deployment-namc-shop></app-deployment-namc-shop>
  </div>

</section>
